/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * From T object, pick a set of properties whose keys are in the union K of T.
 */
export const pick = <T extends Record<string, unknown>, K extends keyof T>(
  obj: T,
  ...keys: K[]
) =>
  Object.fromEntries(
    keys.filter((key) => key in obj).map((key) => [key, obj[key]])
  ) as Pick<T, K>;

/**
 * From T array object, pick a set of properties whose keys are in the union K of T.
 * Returns an array of those properties values.
 */
export const pickFromArray = <
  T extends Record<string, unknown>,
  K extends keyof T
>(
  array: any[],
  ...keys: K[]
) => {
  return array.reduce((accumulator: any[], item) => {
    accumulator.push(pick(item, ...keys));
    return accumulator;
  }, []);
};

/**
 * Check if object is Error type.
 */
export function isError(obj: any) {
  return obj instanceof Error;
}

/**
 * Check if object is an Object type.
 */
export function isObject(obj: any) {
  const type = typeof obj;
  return obj != null && (type == "object" || type == "function");
}

/**
 * Shuffle an array immutably
 */
export const shuffleArray = <T>(array: T[]) => {
  return [...array].sort(() => Math.random() - 0.5);
};
